import { PreflightWrapper } from "@mabi-ui/preflight";
import { cn } from "@mabi-ui/utils";
import { Slot } from "@radix-ui/react-slot";
import { type VariantProps } from "class-variance-authority";
import React, {
  HTMLAttributes,
  ReactNode,
  RefAttributes,
  forwardRef,
} from "react";
import { typography } from "./styles";

function switchComponentVariant(
  variant: VariantProps<typeof typography>["variant"]
) {
  switch (variant) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
      return variant;
    default:
      return "p";
  }
}

export type TypographyProps = {
  children?: ReactNode;
  className?: string;
  asChild?: boolean;
  noWrap?: boolean;
} & VariantProps<typeof typography> &
  HTMLAttributes<HTMLElement>;

export const Typography: React.ForwardRefExoticComponent<
  TypographyProps & RefAttributes<any>
> = forwardRef<any, TypographyProps>(
  ({ variant, className, asChild, noWrap, ...props }, ref) => {
    const Component = asChild ? Slot : switchComponentVariant(variant);
    return (
      <PreflightWrapper>
        <Component
          ref={ref}
          className={cn(
            typography({ variant }),
            noWrap && "truncate",
            className
          )}
          {...props}
        />
      </PreflightWrapper>
    );
  }
);

Typography.displayName = "Typography";
